// extracted by mini-css-extract-plugin
var _1 = "calendarLessonDetail-module_autofill__KhwoMz";
var _2 = "calendarLessonDetail-module_calendar-container__VNvuDH";
var _3 = "calendarLessonDetail-module_calendar-footer-container__Du3z42";
var _4 = "calendarLessonDetail-module_calendar-wrapper__U6F6BW";
var _5 = "calendarLessonDetail-module_calendar_btn_settings__dzZoHh";
var _6 = "calendarLessonDetail-module_calendar_btn_settings_info__xUUPs3";
var _7 = "calendarLessonDetail-module_calendar_container__lL3Oy6";
var _8 = "calendarLessonDetail-module_calendar_footer_box__BfZr3K";
var _9 = "calendarLessonDetail-module_calendar_footer_container__GUFzLT";
var _a = "calendarLessonDetail-module_calendar_icon__LIaNA9";
var _b = "calendarLessonDetail-module_calendar_title__cZuEZk";
var _c = "calendarLessonDetail-module_calendar_title_container__qla_qu";
var _d = "calendarLessonDetail-module_calendar_title_wrapper__XfJdan";
var _e = "calendarLessonDetail-module_calendar_wrapper__wjKjzk";
var _f = "calendarLessonDetail-module_certificate__cPMabk";
var _10 = "calendarLessonDetail-module_color_cube__iGeUle";
var _11 = "calendarLessonDetail-module_color_cube_wrapper__sslZM9";
var _12 = "calendarLessonDetail-module_color_info__Lh9atf";
var _13 = "calendarLessonDetail-module_highlighted__OTagfU";
var _14 = "calendarLessonDetail-module_holidays__a6qDLG";
var _15 = "calendarLessonDetail-module_practice__FLQmp3";
var _16 = "calendarLessonDetail-module_session__rGpJVv";
export { _1 as "autofill", _2 as "calendar-container", _3 as "calendar-footer-container", _4 as "calendar-wrapper", _5 as "calendar_btn_settings", _6 as "calendar_btn_settings_info", _7 as "calendar_container", _8 as "calendar_footer_box", _9 as "calendar_footer_container", _a as "calendar_icon", _b as "calendar_title", _c as "calendar_title_container", _d as "calendar_title_wrapper", _e as "calendar_wrapper", _f as "certificate", _10 as "color_cube", _11 as "color_cube_wrapper", _12 as "color_info", _13 as "highlighted", _14 as "holidays", _15 as "practice", _16 as "session" }
